import React, { useState, useEffect } from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts'
import Grid from '@material-ui/core/Grid'
import { Typography } from '@material-ui/core'
import { Moment } from 'moment'

import { useApiCall } from 'hooks'
import { snackbar } from 'components'
import { ERRORS } from 'consts'
import { COLORS } from 'styles'

import { getCouponsUsage } from '../api'
import { ParametersDownload } from '../types'

interface Props {
  startDate: Moment
  endDate: Moment
}

interface ChartData {
  name: string
  value: number
}

interface CouponUsageData {
  couponName: string
  usageCount: number
}

interface ApiResponse {
  data: CouponUsageData[]
}

const CouponsUsage: React.FC<Props> = ({ startDate, endDate }) => {
  const [data, setData] = useState<ChartData[]>([])

  const [requestCouponsUsage] = useApiCall<ParametersDownload, ApiResponse>(getCouponsUsage)

  useEffect(() => {
    requestCouponsUsage({ startDate, endDate })
      .then(resp => {
        console.log('Raw response:', resp)
        const rawData = resp.data || []
        console.log('Raw data:', rawData)

        const preparedData = rawData.map((item: CouponUsageData) => ({
          name: item.couponName,
          value: item.usageCount,
        }))
        console.log('Prepared data:', preparedData)

        setData(preparedData)
      })
      .catch(error => {
        console.error('Error:', error)
        snackbar.show(ERRORS.GENERIC_ERROR_MESSAGE)
        setData([])
      })
  }, [startDate, endDate, requestCouponsUsage])

  return (
    <Grid
      container
      spacing={2}
      style={{
        background: '#fff',
        boxShadow: '0 2px 7px 0 rgba(0,0,0,.06)',
        padding: '20px',
      }}
    >
      <Grid item xs={12}>
        <Typography variant="h6" style={{ marginBottom: '20px', color: COLORS.FONT }}>
          Uso de Cupones | Usos por categorías
        </Typography>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data} margin={{ top: 5, right: 50, left: 20, bottom: 5 }} barSize={60}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="value" fill="#e78923" />
          </BarChart>
        </ResponsiveContainer>
      </Grid>
    </Grid>
  )
}

export default CouponsUsage
